import { Users, Calendar, Clock, MapPin } from 'lucide-react';

const parties = [
  { 
    name: 'Annual Company Gala', 
    date: 'Jan 25, 2024', 
    time: '7:00 PM',
    location: 'Grand Ballroom',
    attendees: 150 
  },
  { 
    name: 'Product Launch Event', 
    date: 'Feb 10, 2024', 
    time: '2:00 PM',
    location: 'Tech Center',
    attendees: 75 
  },
  { 
    name: 'Team Building Workshop', 
    date: 'Feb 15, 2024', 
    time: '10:00 AM',
    location: 'Conference Room A',
    attendees: 30 
  },
  { 
    name: 'Customer Appreciation Day', 
    date: 'Mar 1, 2024', 
    time: '11:00 AM',
    location: 'Main Hall',
    attendees: 200 
  },
];

export function PartiesIndex() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-2">Parties</h1>
      <p className="text-muted-foreground mb-8">Manage and organize all your events and parties.</p>

      <div className="grid gap-4 md:grid-cols-2">
        {parties.map((party) => (
          <div key={party.name} className="glass-card p-6 rounded-xl hover:border-primary/50 transition-all duration-300">
            <h3 className="font-semibold text-lg mb-4">{party.name}</h3>
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2 text-muted-foreground">
                <Calendar className="h-4 w-4" />
                <span>{party.date}</span>
              </div>
              <div className="flex items-center gap-2 text-muted-foreground">
                <Clock className="h-4 w-4" />
                <span>{party.time}</span>
              </div>
              <div className="flex items-center gap-2 text-muted-foreground">
                <MapPin className="h-4 w-4" />
                <span>{party.location}</span>
              </div>
              <div className="flex items-center gap-2 text-muted-foreground">
                <Users className="h-4 w-4" />
                <span>{party.attendees} attendees</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
